/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  List,
  ListItem,
  ListItemText,
  FormControl,
  FormGroup,
  FormControlLabel,
  TextField,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { get, isEmpty, isNil, uniqueId } from 'lodash';
import { arrayTranslate, translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import SahamAccordion from 'components/SahamAccordion';
import {
  FraudContainer,
  FraudFormWrapper,
} from 'containers/PreOpeningPage/styled-component';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import FraudMotifDialog from 'containers/PreOpeningPage/FraudMotifDialog';
import { Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { OTHER_MOTIF_ID } from 'containers/PreOpeningPage/constants';
import { displayErrorText } from 'containers/services/validateForm';
import { PAGES } from 'routes';
import routesHelper from 'containers/services/routes-helper';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';

export interface FraudeFormProps {
  intl: IntlShape;
  victims?: any;
  vehicles?: any;
  isManager?: boolean;
  lossDate?: string;
  updateFilde?: Function;
  claimToPreopen?: any;
  listings?: Listings;
  isRecapPage?: boolean;
  setClaimRecap?: Function;
  claimRecap?: any;
  fraudInfoValidation?: any;
  isPreOpening?: boolean;
  isCourtManager?: boolean;
  fullWidth?: boolean;
}

const FraudeForm: React.FC<FraudeFormProps> = (props): JSX.Element => {
  const FRAUD_INFO_FIELDS = {
    VICTIMS: 'victims',
    VEHICULES: 'vehicules',
    OPPOSING_LAWYER: 'opposingLawyer',
    COMMENT: 'comment',
    COMMENT_COURT_MANAGER: 'commentCourtManager',
    FRAUD_MOTIFS: 'fraudMotifs',
  };
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    props.fraudInfoValidation,
    translateArrayErrorMessages(props.fraudInfoValidation, true),
  );

  const [isFraudMotifDrawerOpen, setIsFraudMotifDrawerOpen] = useState(false);

  const handleOpenFraudMotif = () => setIsFraudMotifDrawerOpen(true);
  const [expanded, setExpanded] = useState(true);
  const [changedInput, setChangedInput] = useState(false);
  const fraudVictimsIds = get(
    props.claimToPreopen,
    'claim.fraudInfo[0].fraudVictims',
    [],
  ).map((el: any) => el.victimId);
  const fraudVehiculesIds = get(
    props.claimToPreopen,
    'claim.fraudInfo[0].fraudVehicules',
    [],
  ).map((el: any) => el.vehiculeId);
  const [fraudInfo, setFraudInfo] = useState({});
  const [fraudMotifs, setFraudMotifs] = useState<Set<number>>([] as any);
  const [commentMotif, setCommentMotif] = useState<any>(null);
  useEffect(() => {
    if (
      !props.isRecapPage &&
      !isEmpty(get(props.claimToPreopen, 'fraudInfo', null))
    ) {
      setCommentMotif(get(props.claimToPreopen, 'fraudInfo.commentMotif', []));
      setFraudMotifs(
        new Set(get(props.claimToPreopen, 'fraudInfo.fraudMotifs', [])),
      );
      setFraudInfo({
        victims: get(props.claimToPreopen, 'fraudInfo.victims', []),
        vehicules: get(props.claimToPreopen, 'fraudInfo.vehicules', []),
        opposingLawyer: get(
          props.claimToPreopen,
          'fraudInfo.opposingLawyer',
          '',
        ),
        fraudMotifs: get(props.claimToPreopen, 'fraudInfo.fraudMotifs', []),
        comment: get(props.claimToPreopen, 'fraudInfo.comment', ''),
        commentMotif: get(props.claimToPreopen, 'fraudInfo.commentMotif', []),
        decision: get(props.claimToPreopen, 'fraudInfo.decision', []),
      });
    } else if (
      props.isRecapPage &&
      isNil(get(props.claimToPreopen, 'claim.fraudInfo[0].id', null)) &&
      !userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
    ) {
      setCommentMotif(get(fraudInfo, 'commentMotif'));
      setFraudMotifs(new Set(get(fraudInfo, 'fraudMotifs', [])));
      setFraudInfo({
        victims: get(props.claimToPreopen, 'claim.fraudInfo[0].victims', []),
        vehicules: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].vehicules',
          [],
        ),
        opposingLawyer: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].opposingLawyer',
          '',
        ),
        fraudMotifs: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].fraudMotifs',
          [],
        ),
        comment: get(props.claimToPreopen, 'claim.fraudInfo[0].comment', ''),
        commentMotif: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].commentMotif',
          [],
        ),
        decision: get(props.claimToPreopen, 'claim.fraudInfo[0].decision', []),
      });
    } else if (props.isRecapPage && !changedInput) {
      setCommentMotif(
        get(
          get(
            props.claimToPreopen,
            'claim.fraudInfo[0].fraudInfoMotif',
            [],
          ).find((el: any) => el.motifId === OTHER_MOTIF_ID),
          'comment',
          '',
        ),
      );
      setFraudMotifs(
        new Set([
          ...get(
            props.claimToPreopen,
            'claim.fraudInfo[0].fraudInfoMotif',
            [],
          ).map((el: any) => el.motifId),
        ]),
      );
      setFraudInfo({
        victims: get(props.claimToPreopen, 'victims', [])
          .filter((v: any) => fraudVictimsIds.includes(v.id))
          .map((v: any) => v.cin),
        vehicules: get(props.claimToPreopen, 'vehicules', [])
          .filter((v: any) => fraudVehiculesIds.includes(v.id))
          .map((v: any) => v.registrationNumber),
        opposingLawyer: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].opposingLawyer',
          '',
        ),
        fraudMotifs: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].fraudMotifs',
          [],
        ),
        comment: get(props.claimToPreopen, 'claim.fraudInfo[0].comment', ''),
        decision: isEmpty(
          get(props.claimToPreopen, 'claim.fraudInfo[0].fraudDecision', []),
        )
          ? get(props.claimToPreopen, 'claim.fraudInfo[0].decision', {})
          : get(
              props.claimToPreopen,
              'claim.fraudInfo[0].fraudDecision[0]',
              {},
            ),
        commentMotif: get(
          props.claimToPreopen,
          'claim.fraudInfo[0].fraudInfoMotif',
          [],
        ).find((el: any) => el.motifId === OTHER_MOTIF_ID)?.comment,
      });
    }
  }, [props.claimToPreopen, props.isRecapPage]);
  const handleChange = (field: string, param: any = null) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) => {
    const { value } = event.target;
    switch (field) {
      case FRAUD_INFO_FIELDS.OPPOSING_LAWYER:
        setFraudInfo({ ...fraudInfo, opposingLawyer: value });
        if (get(props.claimToPreopen, 'fraudInfo')) {
          get(props.claimToPreopen, 'fraudInfo')['opposingLawyer'] = value;
        } else {
          props.claimToPreopen['fraudInfo'] = {
            ...fraudInfo,
            opposingLawyer: value,
          };
        }
        props.updateFilde &&
          props.updateFilde({
            ...props.claimToPreopen,
            fraudInfo: {
              ...props.claimToPreopen.fraudInfo,
              opposingLawyer: value,
            },
          });
        props.setClaimRecap &&
          props.setClaimRecap({
            ...props.claimRecap,
            claim: {
              ...get(props.claimRecap, 'claim'),
              fraudInfo: [
                {
                  ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                  opposingLawyer: value,
                },
              ],
            },
          });
        break;
      case FRAUD_INFO_FIELDS.COMMENT:
        setChangedInput(true);
        setFraudInfo({ ...fraudInfo, comment: value });
        if (get(props.claimToPreopen, 'fraudInfo'))
          get(props.claimToPreopen, 'fraudInfo')['comment'] = value;
        props.updateFilde &&
          props.updateFilde({
            ...props.claimToPreopen,
            fraudInfo: {
              ...props.claimToPreopen.fraudInfo,
              comment: value,
            },
          });
        props.setClaimRecap &&
          props.setClaimRecap({
            ...props.claimRecap,
            claim: {
              ...get(props.claimRecap, 'claim'),
              fraudInfo: [
                {
                  ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                  comment: value,
                },
              ],
            },
          });
        break;
      case FRAUD_INFO_FIELDS.VICTIMS:
        if (get(fraudInfo, 'victims', []).includes(param)) {
          setFraudInfo({
            ...fraudInfo,
            victims: get(fraudInfo, 'victims', []).filter(
              (item: any) => item !== param,
            ),
          });
          if (get(props.claimToPreopen, 'fraudInfo')) {
            get(props.claimToPreopen, 'fraudInfo')['victims'] = [
              ...get(fraudInfo, 'victims', []).filter(
                (item: any) => item !== param,
              ),
            ];
          } else {
            props.claimToPreopen['fraudInfo'] = {
              ...fraudInfo,
              fraudVictims: [
                ...get(
                  props.claimToPreopen,
                  'fraudInfo[0].fraudVictims',
                  [],
                ).map((item: any) => {
                  if (item.cin) {
                    if (get(fraudInfo, 'victims', []).includes(item.cin)) {
                      return { ...item };
                    } else {
                      return { ...item, isDeleted: true };
                    }
                  } else {
                    return item;
                  }
                }),
                ...get(props.claimRecap, 'victims', [])
                  .filter((el: any) => el.cin === param)
                  .map((it: any) => {
                    if (it.cin) {
                      return {
                        victimId: it.id,
                        fraudInfoId: props.claimToPreopen['fraudInfo[0].id'],
                        isDeleted: false,
                      };
                    } else {
                      return it;
                    }
                  }),
              ],
              victims: [
                ...get(fraudInfo, 'victims', []).filter(
                  (item: any) => item !== param,
                ),
              ],
            };
          }
          props.updateFilde &&
            props.updateFilde({
              ...props.claimToPreopen,
              fraudInfo: {
                ...props.claimToPreopen.fraudInfo,
                victims: [
                  ...get(fraudInfo, 'victims', []).filter(
                    (item: any) => item !== param,
                  ),
                ],
              },
            });
          props.setClaimRecap &&
            props.setClaimRecap({
              ...props.claimRecap,
              claim: {
                ...get(props.claimRecap, 'claim'),
                fraudInfo: [
                  {
                    ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                    victims: [
                      ...get(fraudInfo, 'victims', []).filter(
                        (item: any) => item !== param,
                      ),
                    ],
                  },
                ],
              },
            });
        } else {
          setFraudInfo({
            ...fraudInfo,
            victims: [...get(fraudInfo, 'victims', []), param],
          });
          if (get(props.claimToPreopen, 'fraudInfo'))
            get(props.claimToPreopen, 'fraudInfo')['victims'] = [
              ...get(fraudInfo, 'victims', []),
              param,
            ];
          props.updateFilde &&
            props.updateFilde({
              ...props.claimToPreopen,
              fraudInfo: {
                ...props.claimToPreopen.fraudInfo,
                victims: [...get(fraudInfo, 'victims', []), param],
              },
            });
          props.setClaimRecap &&
            props.setClaimRecap({
              ...props.claimRecap,
              claim: {
                ...get(props.claimRecap, 'claim'),
                fraudInfo: [
                  {
                    ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                    victims: [...get(fraudInfo, 'victims', []), param],
                  },
                ],
              },
            });
        }
        break;
      case FRAUD_INFO_FIELDS.VEHICULES:
        if (get(fraudInfo, 'vehicules', []).includes(param)) {
          setFraudInfo({
            ...fraudInfo,
            vehicules: get(fraudInfo, 'vehicules', []).filter(
              (item: any) => item !== param,
            ),
          });
          if (get(props.claimToPreopen, 'fraudInfo'))
            get(props.claimToPreopen, 'fraudInfo')['vehicules'] = [
              ...get(fraudInfo, 'vehicules', []).filter(
                (item: any) => item !== param,
              ),
            ];
          props.updateFilde &&
            props.updateFilde({
              ...props.claimToPreopen,
              fraudInfo: {
                ...props.claimToPreopen.fraudInfo,
                vehicules: [
                  ...get(fraudInfo, 'vehicules', []).filter(
                    (item: any) => item !== param,
                  ),
                ],
              },
            });
          props.setClaimRecap &&
            props.setClaimRecap({
              ...props.claimRecap,
              claim: {
                ...get(props.claimRecap, 'claim'),
                fraudInfo: [
                  {
                    ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                    vehicules: [
                      ...get(fraudInfo, 'vehicules', []).filter(
                        (item: any) => item !== param,
                      ),
                    ],
                  },
                ],
              },
            });
        } else {
          setFraudInfo({
            ...fraudInfo,
            vehicules: [...get(fraudInfo, 'vehicules', []), param],
          });
          if (get(props.claimToPreopen, 'fraudInfo'))
            get(props.claimToPreopen, 'fraudInfo')['vehicules'] = [
              ...get(fraudInfo, 'vehicules', []),
              param,
            ];
          props.updateFilde &&
            props.updateFilde({
              ...props.claimToPreopen,
              fraudInfo: {
                ...props.claimToPreopen.fraudInfo,
                vehicules: [...get(fraudInfo, 'vehicules', []), param],
              },
            });
          props.setClaimRecap &&
            props.setClaimRecap({
              ...props.claimRecap,
              claim: {
                ...get(props.claimRecap, 'claim'),
                fraudInfo: [
                  {
                    ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                    vehicules: [...get(fraudInfo, 'vehicules', []), param],
                  },
                ],
              },
            });
        }
        break;
      case FRAUD_INFO_FIELDS.COMMENT_COURT_MANAGER:
        setChangedInput(true);
        setFraudInfo({
          ...fraudInfo,
          decision: {
            ...get(fraudInfo, 'decision'),
            comment: value,
            status: 'PENDING',
          },
        });
        props.setClaimRecap &&
          props.setClaimRecap({
            ...props.claimRecap,
            claim: {
              ...get(props.claimRecap, 'claim'),
              fraudInfo: [
                {
                  ...get(props.claimRecap, 'claim.fraudInfo[0]'),
                  decision: {
                    ...get(fraudInfo, 'decision'),
                    comment: value,
                  },
                },
              ],
            },
          });
        break;
      default:
        return props.claimToPreopen;
    }
  };

  const resolveFraudMotifs = (fraudMotifs: any) => {
    const fraudMotifsArr = [...fraudMotifs];
    if (fraudMotifsArr.includes(OTHER_MOTIF_ID)) {
      fraudMotifsArr.splice(fraudMotifsArr.indexOf(OTHER_MOTIF_ID), 1);
      fraudMotifsArr.push(OTHER_MOTIF_ID);
    }
    return fraudMotifsArr;
  };

  const handleChangeExpanded = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpanded(expanded);
  };

  return (
    <FraudContainer>
      <SahamAccordion
        expanded={expanded}
        onChange={handleChangeExpanded}
        title={translate(messages.fraudFormTitle, props)}
        editButtonTitle={
          props.isPreOpening ? translate(messages.updateBtnLabel, props) : null
        }
        editButtonOnClick={() => routesHelper.pushTo(PAGES.PREOPENING)()}
      >
        <>
          <FraudFormWrapper style={{ width: props.fullWidth ? '100%' : '50%' }}>
            <FormControl>
              <TextField
                label={translate(messages.opposingLawyer, props)}
                name={translate(messages.opposingLawyer, props)}
                value={get(fraudInfo, 'opposingLawyer', '')}
                onChange={handleChange(FRAUD_INFO_FIELDS.OPPOSING_LAWYER)}
                disabled={props.isRecapPage || props.isPreOpening}
                error={
                  !!get(props.fraudInfoValidation, [
                    FRAUD_INFO_FIELDS.OPPOSING_LAWYER,
                  ])
                }
                helperText={message[FRAUD_INFO_FIELDS.OPPOSING_LAWYER]}
              />
            </FormControl>
            <FormControl>
              <TextField
                label={translate(messages.lossDate, props)}
                name={translate(messages.lossDate, props)}
                value={props.lossDate}
                disabled
              />
            </FormControl>
            <FormControl>
              {!isEmpty(get(props, 'victims', [])) && (
                <span>{translate(messages.victims, props)}</span>
              )}
              <List>
                {get(props, 'victims', []).map((item: any) => (
                  <ListItem key={item.registrationNumber}>
                    <FormGroup key={uniqueId()}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={get(fraudInfo, 'victims', []).includes(
                              String(item.cin),
                            )}
                            onChange={handleChange(
                              FRAUD_INFO_FIELDS.VICTIMS,
                              item.cin,
                            )}
                            color="primary"
                            disabled={props.isRecapPage || props.isPreOpening}
                          />
                        }
                        label={item.firstName + ' ' + item.lastName}
                      />
                    </FormGroup>
                  </ListItem>
                ))}
              </List>
              {!!get(props.fraudInfoValidation, [
                FRAUD_INFO_FIELDS.VICTIMS,
              ]) && (
                <span style={{ color: 'red' }}>
                  {translate(messages.fraudVictimsRequiredTitle, props)}
                </span>
              )}
            </FormControl>
            <FormControl>
              {!isEmpty(get(props, 'vehicles', [])) && (
                <span>{translate(messages.vehicules, props)}</span>
              )}
              <List>
                {get(props, 'vehicles', []).map((item: any) => (
                  <ListItem key={item.id}>
                    <FormGroup key={uniqueId()}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={get(fraudInfo, 'vehicules', []).includes(
                              item.registrationNumber,
                            )}
                            color="primary"
                            onChange={handleChange(
                              FRAUD_INFO_FIELDS.VEHICULES,
                              item.registrationNumber,
                            )}
                            disabled={props.isRecapPage || props.isPreOpening}
                          />
                        }
                        label={
                          item.registrationNumber
                            ? item.registrationNumber
                            : null + ' - ' + item.firstName
                            ? item.firstName
                            : null + ' ' + item.lastName
                            ? item.lastName
                            : null
                        }
                      />
                    </FormGroup>
                    <ListItemText primary={item.label} />
                  </ListItem>
                ))}
              </List>
            </FormControl>
            <FormControl>
              {(get(fraudInfo, 'comment') ||
                (props.isManager && !get(fraudInfo, 'comment'))) && (
                <TextField
                  label={translate(
                    messages.fraudCommentOpeningManagerTitle,
                    props,
                  )}
                  name={translate(messages.comment, props)}
                  value={get(fraudInfo, 'comment', '')}
                  onChange={handleChange(FRAUD_INFO_FIELDS.COMMENT)}
                  disabled={
                    (get(fraudInfo, 'comment') && props.isCourtManager) ||
                    (get(fraudInfo, 'comment') && !props.isManager)
                  }
                />
              )}
            </FormControl>
            <FormControl>
              {[...resolveFraudMotifs(fraudMotifs)].map(
                (fraudMotifId: any, index: number) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        data-testid={`checkbox-${index}`}
                        checked={true}
                        color="primary"
                      />
                    }
                    label={get(
                      get(props.listings, LISTINGS.FRAUD_MOTIF, []).find(
                        (el: any) => el.id === fraudMotifId,
                      ),
                      'title',
                      '',
                    )}
                  />
                ),
              )}
              {!!get(props.fraudInfoValidation, [
                FRAUD_INFO_FIELDS.FRAUD_MOTIFS,
              ]) && (
                <span style={{ color: 'red' }}>
                  {translate(messages.fraudMotifRequiredTitle, props)}
                </span>
              )}
            </FormControl>
            {commentMotif && [...fraudMotifs].includes(OTHER_MOTIF_ID) && (
              <TextField
                label={translate(messages.fraudOtherMotifTitle, props)}
                name={translate(messages.comment, props)}
                value={commentMotif}
                disabled
              />
            )}
            {!props.isRecapPage && !props.isPreOpening && (
              <PrimaryButton
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                title={translate(messages.fraudMotif, props)}
                onClick={handleOpenFraudMotif}
              />
            )}
            {(get(fraudInfo, 'decision.comment') ||
              (props.isCourtManager &&
                props.isRecapPage &&
                isEmpty(get(fraudInfo, 'fraudDecision', null)))) && (
              <TextField
                label={translate(messages.fraudCommentCourtManagerTitle, props)}
                name={translate(messages.fraudCommentCourtManagerTitle, props)}
                value={get(fraudInfo, 'decision.comment', '')}
                onChange={handleChange(FRAUD_INFO_FIELDS.COMMENT_COURT_MANAGER)}
                disabled={
                  !isEmpty(
                    get(
                      props.claimToPreopen,
                      'claim.fraudInfo[0].fraudDecision',
                    ),
                  )
                }
              />
            )}
          </FraudFormWrapper>
        </>
      </SahamAccordion>
      <FraudMotifDialog
        listings={props.listings}
        fraudMotifs={fraudMotifs}
        setFraudMotifs={setFraudMotifs}
        isOpen={isFraudMotifDrawerOpen}
        setIsFraudMotifDrawerOpen={setIsFraudMotifDrawerOpen}
        updateFilde={props.updateFilde}
        claimToPreopen={props.claimToPreopen}
        setClaimRecap={props.setClaimRecap}
        claimRecap={props.claimRecap}
        commentMotif={commentMotif}
        setCommentMotif={setCommentMotif}
        fraudInfo={fraudInfo}
        setFraudInfo={setFraudInfo}
      />
    </FraudContainer>
  );
};

export default injectIntl(FraudeForm);
